export const PHONE_PATTERN = /^1[3-9]\d{9}$/
export const USERNAME_PATTERN = /^[\p{Script=Han}A-Za-z0-9]{1,10}$/u

export function usernameError(username: string) {
  const value = username.trim()
  if (!value) return '请输入用户名'
  if (!USERNAME_PATTERN.test(value)) return '用户名只能包含中文、字母或数字，最多10个字符'
  return ''
}

export function nicknameError(nickname: string) {
  const value = nickname.trim()
  if (!value) return '请输入新的昵称'
  if (!USERNAME_PATTERN.test(value)) return '昵称只能包含中文、字母或数字，最多10个字符'
  return ''
}

export function phoneError(phone: string) {
  return PHONE_PATTERN.test(phone) ? '' : '请输入正确的11位手机号'
}

export function passwordError(password: string) {
  const length = Array.from(password).length
  if (length < 8 || length > 20) return '密码需为8-20个字符'
  return ''
}

export function passwordChangeError(input: { oldPassword: string; newPassword: string; confirmPassword: string }) {
  if (!input.oldPassword) return '请输入原密码'
  if (passwordError(input.oldPassword)) return '原密码需为8-20个字符'
  if (!input.newPassword) return '请输入新密码'
  const nextError = passwordError(input.newPassword)
  if (nextError) return nextError
  if (input.newPassword === input.oldPassword) return '新密码不能与原密码相同'
  if (input.newPassword !== input.confirmPassword) return '两次输入的新密码不一致'
  return ''
}

export function registrationError(input: {
  username: string
  phone: string
  gender: string
  password: string
  confirmPassword: string
}) {
  return usernameError(input.username)
    || phoneError(input.phone)
    || (!input.gender ? '请选择性别' : '')
    || passwordError(input.password)
    || (input.password !== input.confirmPassword ? '两次输入的密码不一致' : '')
}
